import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-access-state-in-setstate */

/* eslint-disable react/sort-comp */

/* eslint-disable react/no-unused-prop-types */

/* eslint-disable react/static-property-placement */

/* eslint-disable react/state-in-constructor */
import React from 'react';
import PropTypes from 'prop-types';
import unfetch from 'unfetch';
import { requestProduct, updateProduct, failedProduct } from '../../reducers';

var QuickViewFetch = /*#__PURE__*/function (_React$Component) {
  _inherits(QuickViewFetch, _React$Component);

  var _super = _createSuper(QuickViewFetch);

  function QuickViewFetch() {
    var _this;

    _classCallCheck(this, QuickViewFetch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      products: {},
      status: {
        isFetching: false,
        inProgress: [],
        inError: [],
        completed: []
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchProductIfNeeded", function (partNumber) {
      var _this$state = _this.state,
          products = _this$state.products,
          status = _this$state.status;

      if (!products.hasOwnProperty(partNumber) && // eslint-disable-line no-prototype-builtins
      !status.inProgress.includes(partNumber)) {
        _this.setState({
          products: products,
          status: requestProduct(status, partNumber)
        });

        var options = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/vnd.argos-product.v2+json'
          },
          credentials: 'include'
        };
        unfetch("/product-api/pdp-service/partNumber/".concat(partNumber, "?returnMeta=true"), options).then(function (response) {
          return response.json();
        }).then(function (product) {
          var _this$state2 = _this.state,
              latestProducts = _this$state2.products,
              latestStatus = _this$state2.status; // get latest state after async function completes

          var newStatus = updateProduct(latestStatus, product);
          var newState = {
            products: _objectSpread(_objectSpread({}, latestProducts), {}, _defineProperty({}, product.data.id, product)),
            status: newStatus
          };

          _this.setState(newState);
        }).catch(function () {
          return _this.setState({
            status: failedProduct(_this.state.status, partNumber)
          });
        });
      }
    });

    return _this;
  }

  _createClass(QuickViewFetch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchAll(this.props);
    } // eslint-disable-next-line camelcase

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.fetchAll(nextProps);
    }
  }, {
    key: "fetchAll",
    value: function fetchAll(_ref) {
      var _this2 = this;

      var fetch = _ref.fetch,
          partNumbers = _ref.partNumbers;

      if (fetch) {
        partNumbers.map(function (partNumber) {
          return _this2.fetchProductIfNeeded(partNumber);
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
          status = _this$state3.status,
          products = _this$state3.products;
      var render = this.props.render;
      return render({
        products: products,
        isLoading: status.isFetching,
        inError: status.inError
      });
    }
  }]);

  return QuickViewFetch;
}(React.Component);

_defineProperty(QuickViewFetch, "propTypes", {
  fetch: PropTypes.bool,
  partNumbers: PropTypes.arrayOf(PropTypes.string)
});

_defineProperty(QuickViewFetch, "defaultProps", {
  fetch: true,
  partNumbers: []
});

export { QuickViewFetch as default };